interface ContactGraphQLResponse {
  readonly firstName?: string | null;
  readonly lastName?: string | null;
  readonly email?: string | null;
  readonly phoneNumber?: ReadonlyArray<{ readonly number?: string | null } | null> | null;
  readonly household?: {
    readonly address?: {
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly postalCode?: string | null;
      readonly city?: string | null;
      readonly region?: string | null;
      readonly country?: string | null;
      readonly countryCode?: string | null;
      readonly validated?: boolean | null;
    } | null;
  } | null;
}

interface NormalizedContactData
  extends Readonly<{
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    address1: string;
    address2: string;
    postalCode: string;
    city: string;
    region: string;
    country: string;
    countryCode: string;
    validated: boolean;
  }> {}

export const normalizeContactData = (contact?: ContactGraphQLResponse | null): NormalizedContactData => {
  if (!contact) {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      address1: '',
      address2: '',
      postalCode: '',
      city: '',
      region: '',
      country: 'United States',
      countryCode: 'US',
      validated: false,
    };
  }

  return {
    firstName: contact.firstName ?? '',
    lastName: contact.lastName ?? '',
    phoneNumber: contact.phoneNumber?.[0]?.number ?? '',
    email: contact.email ?? '',
    address1: contact.household?.address?.address1 ?? '',
    address2: contact.household?.address?.address2 ?? '',
    postalCode: contact.household?.address?.postalCode ?? '',
    city: contact.household?.address?.city ?? '',
    region: contact.household?.address?.region ?? '',
    country: contact.household?.address?.country ?? 'United States',
    countryCode: contact.household?.address?.countryCode ?? 'US',
    validated: contact.household?.address?.validated ?? false,
  };
};
